<cosmos-section [loading]="(_loading$ | async) === true">
  <div class="cosmos-elements__table__wrapper">
    <cosmos-table
      [columns]="_columns"
      [dataSource]="_dataSource"
      [dataSourceName]="_dataSourceName"
      [hasSearchbar]="true"
      [hasCheckboxFilter]="true"
      (clickedRow)="openDetails($event)"
      class="cosmos-elements__table"
    ></cosmos-table>
  </div>
</cosmos-section>

<ng-template #elementPreview let-data="row">
  <cosmos-element-preview
    [element]="data"
    class="cosmos-elements__preview"
  ></cosmos-element-preview>
</ng-template>
